import React, { useEffect } from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { isIosNative } from './utils';
import { BYO_NGS_RESOURCE_NAME } from './constants';
import { ConnectedApp } from './components/App';
import { store, persistor } from './redux/store';
const App = () => {
    const iosNative = isIosNative();
    useEffect(() => {
        if (!document.getElementById('portal-root-byo')) {
            const elem = document.createElement('div');
            elem.id = 'portal-root-byo';
            elem.setAttribute('style', `position:relative; ${iosNative ? 'z-index:96' : 'z-index:200'};`);
            document.body.appendChild(elem);
        }
    });
    return (React.createElement(Provider, { store: store },
        React.createElement(PersistGate, { loading: null, persistor: persistor },
            React.createElement(Router, null,
                React.createElement(Route, { render: ({ history, location }) => (React.createElement(ConnectedApp, { history: history, location: location })) })))));
};
let socketRef;
const mount = (socket, props) => {
    socketRef = socket;
    render(React.createElement(App, Object.assign({}, props)), socket);
};
const unmount = () => {
    unmountComponentAtNode(socketRef);
};
window[BYO_NGS_RESOURCE_NAME] = {
    default: mount,
    unmount,
};
export default mount;
